import { gsap } from "gsap";
import { isAuthor, isMobile } from "../../../js/utils";
import { ANIMATION, animateObserver, animateWords, fadeIn, parallaxVertical, parallaxVerticalImages } from "../../../js/animations/animations";
import CLASSES from "./utils/class";
// maskIn,
(() => {
  "use strict";

  const BRHCompositionContent = () => {
    const init = () => {
      //== Animations
      if (!isMobile() && !isAuthor()) {
        /* *** TWO TEXT BLOCKS *** */
        const twoTextBlocks = document.querySelectorAll(CLASSES.layouts.twoTextBlocks);
        if (twoTextBlocks.length > 0) {
          twoTextBlocks?.forEach((element) => {
            const appearances = gsap.timeline();

            const title = element.querySelector(ANIMATION.selectors.animatedWords);
            title && appearances.add(animateWords({ classElement: title }), 0);

            const paragraph = element.querySelectorAll(ANIMATION.selectors.animatedParagraph);
            paragraph.length > 0 && appearances.add(fadeIn({ classElement: paragraph, duration: 2 }), 0);
            appearances.pause();

            animateObserver({ elementToObserve: title, animation: () => appearances, threshold: 0 });
          });
        }

        /* *** TWO MULTIMEDIA BLOCKS *** */
        const twoMultimediaBlocks = document.querySelectorAll(CLASSES.layouts.twoMultimediaBlocks);
        if (twoMultimediaBlocks.length > 0) {
          twoMultimediaBlocks?.forEach((element) => {
            const timeline = gsap.timeline({
              scrollTrigger: {
                trigger: element,
                toggleActions: "none none none none",
                start: "top center",
                end: "bottom top",
                scrub: true,
              },
            });
            const multimedia02 = element.querySelector(ANIMATION.selectors.outerParallaxVertical);
            multimedia02 && timeline.add(parallaxVertical({ classElement: multimedia02, startsY: -50, endsY: 40 }), 0);

            const appearances = gsap.timeline();

            appearances.duration(2);
            appearances.pause();

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }

        /* *** THREE MULTIMEDIA *** */
        const threeMultimedia = document.querySelectorAll(CLASSES.layouts.threeMultimedia);
        if (threeMultimedia.length > 0) {
          const paddingTop = window.getComputedStyle(threeMultimedia[0]).paddingTop;
          threeMultimedia.forEach((element) => {
            const timeline = gsap.timeline({
              scrollTrigger: {
                trigger: element,
                toggleActions: "none none none none",
                start: `top+=${paddingTop} center`,
                end: `bottom-=${paddingTop} top`,
                scrub: true,
              },
            });

            const cards = element.querySelectorAll(ANIMATION.selectors.parallaxVertical);
            cards.forEach((card, index) => {
              timeline.add(parallaxVertical({ classElement: card, startsY: 0, endsY: index === 1 ? 100 : -100 }), 0);
              const image = card.querySelector(".cmp-image__image");
              image && timeline.add(parallaxVerticalImages({ classElement: image, startsY: 0, endsY: index === 1 ? 150 : 100 }), 0);
            });
          });
        }

        /* *** THREE MULTIMEDIA COLLAGE *** */
        const threeMultimediaCollage = document.querySelectorAll(CLASSES.layouts.threeMultimediaCollage);
        if (threeMultimediaCollage.length > 0) {
          threeMultimediaCollage.forEach((element) => {
            const timeline = gsap.timeline({
              scrollTrigger: {
                trigger: element,
                toggleActions: "none none none none",
                start: `top center`,
                end: `bottom top`,
                scrub: true,
              },
            });

            const cardLeft = element.querySelectorAll(ANIMATION.selectors.parallaxVerticalBottom);
            cardLeft.forEach((card) => {
              timeline.add(parallaxVertical({ classElement: card, startsY: 0, endsY: 300, scale: 1.1 }), 0);
            });

            const cardsRight = element.querySelectorAll(ANIMATION.selectors.parallaxVertical);
            cardsRight.forEach((card) => {
              timeline.add(parallaxVertical({ classElement: card, startsY: 0, endsY: 600 }), 0);

              const image = card.querySelector(".cmp-image__image");
              image && timeline.add(parallaxVerticalImages({ classElement: image, startsY: -120, endsY: 120, scale: 1.1 }), 0);
              const video = card.querySelectorAll(".brh-video__player");
              video.length > 0 && timeline.add(parallaxVerticalImages({ classElement: video, startsY: -20, endsY: 200, scale: 1.1 }), 0);
            });

            const appearances = gsap.timeline();

            // const multimedia = element.querySelectorAll(ANIMATION.selectors.parallaxVertical);
            // multimedia[1] && timeline.add(parallaxVerticalImages({ classElement: multimedia[0], startsY: 100, endsY: -50 }), 0);
            // multimedia[0] && timeline.add(parallaxVerticalImages({ classElement: multimedia[1], startsY: 0, endsY: 150 }), 0);

            const defaultTitles = element.querySelectorAll(`.brh-title__text--default.js-animate-words`);
            defaultTitles.length > 0 && appearances.add(animateWords({ classElement: defaultTitles }), 0);

            const decorativeTitles = element.querySelectorAll(`.brh-title__text--decorative${ANIMATION.selectors.animatedWords}`);
            decorativeTitles.length > 0 && appearances.add(fadeIn({ classElement: decorativeTitles, duration: 2 }), 0);

            const paragraph = element.querySelectorAll(ANIMATION.selectors.animatedParagraph);
            paragraph.length > 0 && appearances.add(fadeIn({ classElement: paragraph, duration: 2 }), 0);

            // const imagesToMask = element.querySelectorAll(ANIMATION.selectors.outmaskLeftToRight);
            // imagesToMask.length > 0 && appearances.add(maskIn({ classElement: imagesToMask, duration: 2 }), 0);
            appearances.duration(2);
            appearances.pause();

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }

        /* *** SIX MULTIMEDIA *** */
        const sixMultimedia = document.querySelectorAll(CLASSES.layouts.sixMultimedia);
        if (sixMultimedia.length > 0) {
          sixMultimedia.forEach((element) => {
            const timeline = gsap.timeline({
              scrollTrigger: {
                trigger: element,
                toggleActions: "none none none none",
                start: `top center`,
                end: `bottom center-=15%`,
                scrub: true,
              },
            });

            gsap.timeline({
              scrollTrigger: {
                trigger: CLASSES.layouts.sixMultimedia,
                toggleActions: "none none none none",
                start: `top top`,
                end: `bottom center-=15%`,
                scrub: true,
                pin: CLASSES.elements.panelLeft,
              },
            });

            const cards = element.querySelectorAll(ANIMATION.selectors.parallaxVertical);
            cards.forEach((card, index) => {
              timeline.add(parallaxVertical({ classElement: card, startsY: 0, endsY: index == 0 ? 200 : -200 }), 0);

              const image = card.querySelector(".cmp-image__image");
              image && timeline.add(parallaxVerticalImages({ classElement: image, startsY: -20, endsY: 200 }), 0);
            });

            const appearances = gsap.timeline();
            const titles = element.querySelectorAll(ANIMATION.selectors.animatedWords);
            titles.length > 0 && appearances.add(animateWords({ classElement: titles }), 0);

            const paragraphs = element.querySelectorAll(ANIMATION.selectors.animatedParagraph);
            paragraphs.length > 0 && appearances.add(fadeIn({ classElement: paragraphs, duration: 2 }), 0);

            appearances.pause();

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
      }
    };

    init();
  };

  document.addEventListener("DOMContentLoaded", BRHCompositionContent);
})();
